import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { noop } from 'ui-components/default-props/noop';

import LabelQueHeader from '../../components/label-que-header';
import { EmptyQuePlaceholder } from '../empty-que-placeholder';
import LabelQueBatches from '../label-que-batches';
import sharedStyle from '../../style.module.less';

const LabelQueContent = ({ batchCount = 0, onToggleQue = noop }) => {
  return (
    <React.Fragment>
      <div className={sharedStyle.header}>
        <div className={sharedStyle['header-label']}>
          <FormattedMessage defaultMessage='Label Queue' description='labelQue.header' id='ELYQFE' />
        </div>
        <div>
          <Button className={sharedStyle['toggle-que']} onClick={onToggleQue} theme='unstyled'>
            <FontAwesomeIcon icon={faXmark} />
          </Button>
        </div>
      </div>
      <LabelQueHeader />
      {batchCount === 0 && <EmptyQuePlaceholder />}
      {batchCount > 0 && <LabelQueBatches />}
    </React.Fragment>
  );
};

LabelQueContent.propTypes = {
  batchCount: PropTypes.number,
  onToggleQue: PropTypes.func,
};

export default LabelQueContent;
